module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item dropdown notification-list"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle arrow-none waves-effect waves-light nav-user",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "false",
      "aria-expanded": "false"
    }
  }, [_c('gravatar', {
    staticClass: "img-circle",
    attrs: {
      "email": _vm.user.email,
      "alt": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-arrow profile-dropdown",
    attrs: {
      "aria-labelledby": "Preview"
    }
  }, [_c('div', {
    staticClass: "dropdown-item noti-title"
  }, [_c('h5', {
    staticClass: "text-overflow"
  }, [_c('small', [_vm._v(_vm._s(_vm.user.name))])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.impersonate
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-accounts-alt"
  }), _vm._v(" "), _c('span', [_vm._v("Autre compte")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "to": "/preferences"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-settings"
  }), _vm._v(" "), _c('span', [_vm._v("Préférences")])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.lock
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-lock-open"
  }), _vm._v(" "), _c('span', [_vm._v("Verouiller session")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "to": "/session/logout"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-power"
  }), _vm._v(" "), _c('span', [_vm._v("Déconnexion")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a065fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/TopBar/Navigation/LiAccount.vue
// module id = 662
// module chunks = 1